import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

export interface ConfirmDeleteCustomerData {
  customerId: number | string;
  customerName: string;
  accountNumber?: string;
}

@Component({
  selector: 'app-confirm-delete-customer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './confirm-delete-customer.component.html',
  styleUrl: './confirm-delete-customer.component.scss',
})
export class ConfirmDeleteCustomerComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteCustomerData,
    private dialogRef: MatDialogRef<ConfirmDeleteCustomerComponent>
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
